<template>
  <div class="panel">
    <div class="panel__content">
      <div class="panel__header">
        <h2 class="panel__title panel__title--minor">
					<b>Lifetime Value</b> por Cliente
        </h2>
      </div>
      <div class="panel__body">

        <div class="empty" v-if="loading">
			<p>{{ __e('LOADING') }}</p>
        </div>

        <div class="panel__numbers__data --ticket" v-if="!loading">
					<h3 class="panel__numbers__data__label">
						Ticket Médio geral<br/>
					</h3>
					<h4 class="panel__numbers__data__number" v-if="ltv.ticket_medio">
						<span class="number--normal">{{ ltv.ticket_medio | numberToReal }}</span>
					</h4>
					<h4 class="panel__numbers__data__number" v-else>
						<small class="empty-text">{{ __e('NO_DATA') }}</small>
					</h4>
				</div>
				
				<div class="panel__numbers__data --ltv" v-if="!loading">
					<h3 class="panel__numbers__data__label">LTV <InfoTooltip :text="__e('LTV_EXPLAIN')" /></h3>
					<h4 class="panel__numbers__data__number" v-if="ltv.ltv">
							<span class="number--normal">{{ ltv.ltv | numberToReal }} 
							<i
								v-if="ltvIsSufficient"
								:title="__e('LTV_PERIOD')"
								v-b-tooltip.hover.right>
									<IconCheck icon-color="#73cb53"></IconCheck>
							</i>
							</span>
					</h4>
					<h4 class="panel__numbers__data__number" v-else>
							<small class="empty-text">{{ __e('NO_DATA') }}</small>
					</h4>
        </div>

        
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { numberToReal } from "@/utils/money";
import { percentage } from "@/utils/masks";
import { fetchLtv } from "@/api/customers";
import IconCheck from "@/components/icones/iconCheck.vue";
import InfoTooltip from "@/components/info-tooltip/InfoTooltip.vue";
import { __e } from "@/utils/messages";
export default {
	components: {
		IconCheck,
		InfoTooltip,
	},
	methods: {
		fetchLtv,
		__e,
	},
  filters: {
    numberToReal,
    percentage,
  },
  mounted() {
		this.fetchLtv(this.start, this.end);
  },
  data() {
    return {
			innerWidth: window.innerWidth,
			loading: true,
      data: {
				start: null,
				end: null,
      },
    };
  },
  computed: {
    ...mapState({
      ltv: (state) => state.customers.ltv,
      ltvIsSufficient: (state) => state.customers.ltvIsSufficient,
    }),
  },
	watch: {
		ltv: {
			handler() {
				this.loading = false;
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss">
.panel {
	&__numbers {
		&__data {
			&.--ticket {
				margin-top: 1rem;
			}
			&.--ltv {
				margin-top: 1rem;
			}
			// &__label {
			// 	font-size: 1.2rem;
			// }
			// &__number {
			// 	font-size: 2rem;
			// }
		}
	}
}

// @media only screen and (max-width: 991px) {
//   .value {
//     &__content {
//       padding: 15px;
//     }
//   }
// }
</style>
